module.exports = __webpack_public_path__ + "img/小图3.9795f61f.png";